import { Component, attr } from "../Component";
import {element} from "../CustomElement";
import { Page } from "../flipp-page/Page";
import {isCrawler} from "../../utils/crawler";

interface ICityHomepage {
	flyers: string;
	coupons: string;
	withSidebar: string;
	cityH1: string;
}

interface ILink {
	href: string;
	name: string;
}

@element("flipp-city-homepage")
export class CityHomepage extends Component<ICityHomepage, {}> {
	@attr flyers: string;
	@attr coupons: string;
	@attr withSidebar: string;
	@attr cityH1: string;

	renderLinks(links: ILink[]): HTMLElement {
		return (
			<ol>
				{links.map((link: ILink) => {
					const {href, name} = link;
					return <div>
						<li><a href={href}>{name}</a></li>
					</div>;
				})}
			</ol>
		);
	}

	getCityH1(): HTMLElement|null {
		return isCrawler() ? <h1>{this.cityH1}</h1> : null;
	}

	render() {
		const coupons = JSON.parse(this.props.coupons);
		const flyers = JSON.parse(this.props.flyers);

		return (
			<Page show="flyers" withSidebar={this.withSidebar}>
				{this.getCityH1()}
				<section id="city-homepage-top-flyers">
					<h2>Top Flyers</h2>
					{this.renderLinks(flyers)}
				</section>
				<section id="city-homepage-top-coupons">
					<h2>Top Coupons</h2>
					{this.renderLinks(coupons)}
				</section>
			</Page>
		);
	}
}
